// Casa Nuvé — custom theme global behavior
(function () {
  'use strict';

  var root = document.documentElement;

  /* ---------- Cart drawer ---------- */
  /* Cart and wishlist are both right-side panels at the same position/size — opening one
     while the other is already open would stack them exactly on top of each other with no
     visual indication, so each open() call closes the other first. */
  function openCart() { root.removeAttribute('data-wishlist-open'); root.setAttribute('data-cart-open', ''); document.body.style.overflow = 'hidden'; }
  function closeCart() { root.removeAttribute('data-cart-open'); if (!root.hasAttribute('data-mobile-nav-open')) document.body.style.overflow = ''; }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open-btn]')) { e.preventDefault(); openCart(); refreshCart(); }
    if (e.target.closest('[data-cart-close-btn]') || e.target.matches('.cart-drawer__overlay')) { closeCart(); }
    if (e.target.closest('[data-mobile-nav-open-btn]')) { root.setAttribute('data-mobile-nav-open', ''); document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-mobile-nav-close-btn]') || (e.target.matches('.cart-drawer__overlay') && root.hasAttribute('data-mobile-nav-open'))) {
      root.removeAttribute('data-mobile-nav-open'); document.body.style.overflow = '';
    }
    var subToggle = e.target.closest('[data-mobile-sub-toggle]');
    if (subToggle) {
      var sub = subToggle.closest('.mobile-nav__item').querySelector('.mobile-nav__sub');
      if (sub) sub.classList.toggle('is-open');
    }
    if (e.target.closest('[data-filters-open]')) {
      var panel = document.querySelector('[data-filters-panel]');
      if (panel) { panel.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    }
    if (e.target.closest('[data-filters-close]')) {
      var panel2 = document.querySelector('[data-filters-panel]');
      if (panel2) { panel2.classList.remove('is-open'); document.body.style.overflow = ''; }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart(); root.removeAttribute('data-mobile-nav-open'); document.body.style.overflow = '';
      root.removeAttribute('data-wishlist-open');
      var openPanel = document.querySelector('[data-filters-panel].is-open');
      if (openPanel) openPanel.classList.remove('is-open');
    }
  });

  /* ---------- Cart AJAX ---------- */
  /* Matches the "$XX.XX" format Shopify's own `| money` filter produces server-side (used for
     every initial page render) — AJAX-updated amounts used to fall back to "XX.XX USD" instead,
     so a line's price visibly changed format the moment you touched +/-. */
  function renderMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCartDrawer);
  }

  /* Updates the free-shipping progress bar. Uses querySelectorAll because the drawer AND the
     standalone /cart page can both have one mounted in the DOM at the same time.
     Only ever touches the fill width and the [data-cart-progress-amount] number — the
     translated prefix/suffix/unlocked text stays exactly as server-rendered and is only
     shown/hidden via the [hidden] attribute, never rewritten through .textContent (which
     would print any HTML entity in the translation, e.g. an apostrophe, as literal text). */
  function updateCartProgress(cart) {
    var els = document.querySelectorAll('[data-cart-progress]');
    if (!els.length) return;
    var threshold = ((window.themeSettings && window.themeSettings.freeShippingThreshold) || 70) * 100;
    var remaining = threshold - cart.items_subtotal_price;
    els.forEach(function (el) {
      if (!cart.item_count) { el.style.display = 'none'; return; }
      el.style.display = '';
      var fill = el.querySelector('.cart-progress__fill');
      var pending = el.querySelector('[data-cart-progress-pending]');
      var unlocked = el.querySelector('[data-cart-progress-unlocked]');
      var amount = el.querySelector('[data-cart-progress-amount]');
      if (remaining <= 0) {
        if (fill) fill.style.width = '100%';
        if (pending) pending.hidden = true;
        if (unlocked) unlocked.hidden = false;
        el.setAttribute('data-complete', '');
      } else {
        var pct = Math.min(100, (cart.items_subtotal_price / threshold) * 100);
        if (fill) fill.style.width = pct + '%';
        if (amount) amount.textContent = '$' + (remaining / 100).toFixed(2);
        if (pending) pending.hidden = false;
        if (unlocked) unlocked.hidden = true;
        el.removeAttribute('data-complete');
      }
    });
  }

  /* Rebuilds every mounted cart surface (the drawer, and the standalone /cart page when
     present) from one fetched cart object, via querySelectorAll instead of querySelector —
     previously only the (possibly hidden) drawer was updated, so clicking +/- or Remove on the
     actual /cart page silently changed the cart while the visible line items never moved. */
  function renderCartDrawer(cart) {
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count ? 'flex' : 'none'; });
    updateCartProgress(cart);

    var bodies = document.querySelectorAll('[data-cart-drawer-body]');
    var footers = document.querySelectorAll('[data-cart-drawer-footer]');
    var subtotals = document.querySelectorAll('[data-cart-subtotal]');
    if (!bodies.length) return;

    if (!cart.item_count) {
      var emptyText = (window.themeStrings && window.themeStrings.cartEmpty) || 'Your cart is empty.';
      bodies.forEach(function (body) { body.innerHTML = '<div class="cart-drawer__empty"><p>' + emptyText + '</p></div>'; });
      footers.forEach(function (footer) { footer.style.display = 'none'; });
      return;
    }

    footers.forEach(function (footer) { footer.style.display = ''; });

    var html = cart.items.map(function (item) {
      return '' +
        '<div class="cart-line" data-line-key="' + item.key + '">' +
          '<a href="' + item.url + '"><img src="' + item.image + '&width=200" alt="' + item.product_title + '"></a>' +
          '<div>' +
            '<a href="' + item.url + '" class="cart-line__title">' + item.product_title + '</a>' +
            (item.variant_title ? '<div style="font-size:12px;opacity:.6;margin-top:4px;">' + item.variant_title + '</div>' : '') +
            '<div class="cart-line__qty">' +
              '<button type="button" data-cart-qty="-1">−</button>' +
              '<input type="text" value="' + item.quantity + '" readonly>' +
              '<button type="button" data-cart-qty="1">+</button>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-cart-remove>' + ((window.themeStrings && window.themeStrings.remove) || 'Remove') + '</button>' +
          '</div>' +
          '<div>' + renderMoney(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');
    bodies.forEach(function (body) { body.innerHTML = html; });

    var subtotalText = renderMoney(cart.items_subtotal_price);
    subtotals.forEach(function (el) { el.textContent = subtotalText; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('form[action*="/cart/add"]')) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.original = submitBtn.textContent; submitBtn.textContent = (window.themeStrings && window.themeStrings.adding) || 'Adding…'; }
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (submitBtn) {
            submitBtn.classList.add('btn--success');
            submitBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" style="width:16px;height:16px;"><polyline points="20 6 9 17 4 12"></polyline></svg>';
            setTimeout(function () {
              submitBtn.disabled = false;
              submitBtn.classList.remove('btn--success');
              submitBtn.textContent = submitBtn.dataset.original;
            }, 1100);
          }
          openCart();
          refreshCart();
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.original; }
        });
    }
  });

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      var line = qtyBtn.closest('[data-line-key]');
      var key = line.dataset.lineKey;
      var input = line.querySelector('input');
      var newQty = Math.max(0, parseInt(input.value, 10) + parseInt(qtyBtn.dataset.cartQty, 10));
      updateLine(key, newQty);
    }
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      var line2 = removeBtn.closest('[data-line-key]');
      updateLine(line2.dataset.lineKey, 0);
    }
  });

  function updateLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCartDrawer);
  }

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-gallery]');
      var main = gallery.querySelector('[data-gallery-main] img');
      main.src = thumb.dataset.full || thumb.src;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    }
  });

  /* ---------- Quantity selector (product form) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-btn]');
    if (btn) {
      var wrap = btn.closest('.qty-selector');
      var input = wrap.querySelector('input');
      var val = Math.max(1, parseInt(input.value || '1', 10) + parseInt(btn.dataset.qtyBtn, 10));
      input.value = val;
    }
  });

  /* ---------- Hero carousel ---------- */
  document.querySelectorAll('[data-hero-carousel]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-hero-slide]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    if (slides.length < 2) return;
    var current = 0;
    var timer;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      var ms = parseInt(hero.dataset.autoplay, 10);
      if (!ms) return;
      clearInterval(timer);
      timer = setInterval(next, ms);
    }

    hero.querySelectorAll('[data-hero-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.heroDot, 10)); startAutoplay(); });
    });
    var nextBtn = hero.querySelector('[data-hero-next]');
    var prevBtn = hero.querySelector('[data-hero-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });

    hero.addEventListener('mouseenter', function () { clearInterval(timer); });
    hero.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });

  /* ---------- Hero parallax (subtle depth on scroll) ---------- */
  var heroEl = document.querySelector('.hero');
  if (heroEl && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    var heroImgs = heroEl.querySelectorAll('.hero__media img');
    var ticking = false;
    function updateParallax() {
      var rect = heroEl.getBoundingClientRect();
      var progress = Math.min(Math.max(-rect.top / (rect.height || 1), 0), 1);
      var shift = progress * 60;
      heroImgs.forEach(function (img) { img.style.transform = 'translateY(' + shift + 'px) scale(1.08)'; });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(updateParallax); ticking = true; }
    }, { passive: true });
    updateParallax();
  }

  /* ---------- Scroll reveal ---------- */
  var animated = document.querySelectorAll('[data-animate]');
  if ('IntersectionObserver' in window && animated.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.15 });
    animated.forEach(function (el) { io.observe(el); });
    setTimeout(function () { animated.forEach(function (el) { el.classList.add('is-visible'); }); }, 1200);
  } else {
    animated.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Trust-bar count-up ---------- */
  var countEls2 = document.querySelectorAll('[data-count-to]');
  if ('IntersectionObserver' in window && countEls2.length) {
    var countIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        countIo.unobserve(entry.target);
        var target = parseInt(entry.target.dataset.countTo, 10);
        var duration = 1100;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          entry.target.textContent = Math.round(eased * target);
          if (p < 1) window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    countEls2.forEach(function (el) { countIo.observe(el); });
  }

  /* Initial cart count + free-shipping progress on load */
  document.addEventListener('DOMContentLoaded', function () {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count; el.style.display = cart.item_count ? 'flex' : 'none';
      });
      updateCartProgress(cart);
    });
  });

  /* ---------- Sticky header — compact on scroll ---------- */
  var siteHeaderEl = document.querySelector('.site-header');
  if (siteHeaderEl) {
    var headerTicking = false;
    function updateHeaderScrolled() {
      siteHeaderEl.classList.toggle('is-scrolled', window.scrollY > 40);
      headerTicking = false;
    }
    window.addEventListener('scroll', function () {
      if (!headerTicking) { window.requestAnimationFrame(updateHeaderScrolled); headerTicking = true; }
    }, { passive: true });
    updateHeaderScrolled();
  }

  /* ---------- Sticky mobile Add to Cart (product page) ----------
     Re-queries the anchor/footer live on every scroll tick instead of relying on
     IntersectionObserver against a node reference captured once at load — keeps this
     correct even if the section markup gets re-rendered after initial page load. */
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  if (stickyAtc) {
    var atcTicking = false;
    function updateStickyAtc() {
      var anchor = document.querySelector('[data-main-atc-anchor]');
      var footerEl = document.querySelector('.site-footer');
      var pastAnchor = anchor ? anchor.getBoundingClientRect().bottom < 0 : false;
      var footerVisible = footerEl ? footerEl.getBoundingClientRect().top < window.innerHeight : false;
      stickyAtc.classList.toggle('is-visible', pastAnchor && !footerVisible);
      atcTicking = false;
    }
    window.addEventListener('scroll', function () {
      if (!atcTicking) { window.requestAnimationFrame(updateStickyAtc); atcTicking = true; }
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (!atcTicking) { window.requestAnimationFrame(updateStickyAtc); atcTicking = true; }
    }, { passive: true });
    updateStickyAtc();

    stickyAtc.addEventListener('click', function (e) {
      if (e.target.closest('[data-sticky-atc-add]')) {
        var anchor = document.querySelector('[data-main-atc-anchor]');
        var mainSubmitBtn = anchor && anchor.querySelector('button[type="submit"]');
        if (mainSubmitBtn && !mainSubmitBtn.disabled) mainSubmitBtn.click();
      }
    });
  }

  /* ---------- Variant picker sync (product page) ----------
     Fix: selecting a variant option (e.g. a color) previously never updated the
     hidden "id" field, price, or availability — Add to Cart always submitted the
     first/default variant regardless of what was selected. This reads the full
     variants list from the embedded JSON and keeps everything in sync. */
  document.querySelectorAll('[data-variant-json]').forEach(function (jsonEl) {
    var infoEl = jsonEl.closest('.product-info');
    var form = infoEl && infoEl.querySelector('.product-form');
    if (!form) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var selects = Array.prototype.slice.call(form.querySelectorAll('select[data-option-index]'));
    if (!selects.length) return;
    var hiddenId = form.querySelector('input[name="id"]');
    var priceEl = infoEl.querySelector('.product-info__price');
    var stockEl = infoEl.querySelector('[data-stock-note]');
    var submitBtn = form.querySelector('button[type="submit"]');
    var mainImg = document.querySelector('[data-gallery-main] img');
    var stickyPrice = document.querySelector('.sticky-atc__price');

    function formatPrice(cents) {
      return '$' + (parseFloat(cents) / 100).toFixed(2);
    }

    function findVariant() {
      var opts = selects.map(function (s) { return s.value; });
      return variants.filter(function (v) {
        return [v.option1, v.option2, v.option3].every(function (o, i) {
          return opts[i] === undefined || o === opts[i];
        });
      })[0];
    }

    function applyVariant() {
      var v = findVariant();
      if (!v) return;
      if (hiddenId) hiddenId.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = (v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price))
          ? '<s style="opacity:.5;margin-right:10px;">' + formatPrice(v.compare_at_price) + '</s>' + formatPrice(v.price)
          : formatPrice(v.price);
      }
      if (submitBtn) {
        submitBtn.disabled = !v.available;
        submitBtn.textContent = v.available
          ? (submitBtn.dataset.addText || submitBtn.textContent)
          : (submitBtn.dataset.soldOutText || submitBtn.textContent);
      }
      if (stockEl) {
        var low = v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= 5;
        if (low) {
          stockEl.textContent = (stockEl.dataset.prefix || '') + v.inventory_quantity + (stockEl.dataset.suffix || '');
          stockEl.hidden = false;
        } else {
          stockEl.hidden = true;
        }
      }
      if (mainImg && v.featured_image && v.featured_image.src) {
        var sep = v.featured_image.src.indexOf('?') === -1 ? '?' : '&';
        mainImg.src = v.featured_image.src + sep + 'width=1000';
      }
      if (stickyPrice) stickyPrice.textContent = formatPrice(v.price);
    }

    selects.forEach(function (s) { s.addEventListener('change', applyVariant); });
  });

  /* ---------- Product image lightbox (click to zoom) ---------- */
  var lightbox = document.querySelector('[data-image-lightbox]');
  if (lightbox) {
    var lightboxImg = lightbox.querySelector('[data-lightbox-img]');
    function openLightbox(src, alt) {
      lightboxImg.src = src;
      lightboxImg.alt = alt || '';
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox() {
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    document.addEventListener('click', function (e) {
      var zoomable = e.target.closest('[data-zoomable]');
      if (zoomable) {
        var full = zoomable.src.replace(/width=\d+/, 'width=1800');
        openLightbox(full, zoomable.alt);
      }
      if (e.target.closest('[data-lightbox-close]') || e.target === lightbox || e.target === lightboxImg) {
        closeLightbox();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }

  /* ---------- Wishlist (localStorage, no customer account needed) ----------
     Snapshot data (title/image/price/url) is read from data-* attributes set by Liquid at
     render time — deliberately NOT a JSON blob embedded in the attribute itself, since a
     product title containing an apostrophe would break out of a single-quoted HTML attribute
     even after the `json` filter (which escapes for JSON syntax, not for HTML attributes). */
  var WISHLIST_KEY = 'casaNuveWishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }

  function isWishlisted(handle) {
    return getWishlist().some(function (item) { return item.handle === handle; });
  }

  function renderWishlistDrawer(list) {
    var body = document.querySelector('[data-wishlist-body]');
    if (!body) return;
    if (!list.length) {
      var tpl = document.querySelector('[data-wishlist-empty-template]');
      body.innerHTML = tpl ? tpl.innerHTML : '';
      return;
    }
    var removeText = (window.themeStrings && window.themeStrings.remove) || 'Remove';
    body.innerHTML = list.map(function (item) {
      return '' +
        '<div class="wishlist-line" data-wishlist-line="' + item.handle + '">' +
          '<a href="' + item.url + '"><img src="' + item.image + '" alt="' + item.title + '"></a>' +
          '<div>' +
            '<a href="' + item.url + '" class="cart-line__title">' + item.title + '</a>' +
            '<div class="wishlist-line__price">' + renderMoney(item.price) + '</div>' +
            '<button type="button" class="cart-line__remove" data-wishlist-remove="' + item.handle + '">' + removeText + '</button>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  function updateWishlistUI() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.style.display = list.length ? 'flex' : 'none';
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-active', isWishlisted(btn.dataset.wishlistHandle));
    });
    renderWishlistDrawer(list);
  }

  function setWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    updateWishlistUI();
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      var handle = toggleBtn.dataset.wishlistHandle;
      var list = getWishlist();
      var idx = list.findIndex(function (item) { return item.handle === handle; });
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.unshift({
          handle: handle,
          title: toggleBtn.dataset.wishlistTitle,
          image: toggleBtn.dataset.wishlistImage,
          url: toggleBtn.dataset.wishlistUrl,
          price: parseInt(toggleBtn.dataset.wishlistPrice, 10) || 0
        });
      }
      setWishlist(list);
    }

    if (e.target.closest('[data-wishlist-open-btn]')) {
      root.removeAttribute('data-cart-open');
      root.setAttribute('data-wishlist-open', '');
      document.body.style.overflow = 'hidden';
    }
    if (e.target.closest('[data-wishlist-close-btn]') || e.target.matches('.wishlist-drawer__overlay')) {
      root.removeAttribute('data-wishlist-open');
      document.body.style.overflow = '';
    }

    var removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      var handleToRemove = removeBtn.dataset.wishlistRemove;
      setWishlist(getWishlist().filter(function (item) { return item.handle !== handleToRemove; }));
    }
  });

  document.addEventListener('DOMContentLoaded', updateWishlistUI);

  /* ---------- Recently viewed (localStorage) ----------
     Tracking (pushing the current product into storage) always runs on a product page.
     Rendering the "Recently viewed" row only happens if there's something else to show —
     the section stays hidden on a customer's very first product view. */
  var RECENTLY_VIEWED_KEY = 'casaNuveRecentlyViewed';
  var currentProductEl = document.querySelector('[data-current-product]');
  if (currentProductEl) {
    try {
      var currentProduct = JSON.parse(currentProductEl.textContent);
      var viewed;
      try { viewed = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || []; } catch (e) { viewed = []; }
      viewed = viewed.filter(function (p) { return p.handle !== currentProduct.handle; });

      var recentSection = document.querySelector('[data-recently-viewed]');
      if (recentSection && viewed.length) {
        var grid = recentSection.querySelector('[data-recently-viewed-grid]');
        grid.innerHTML = viewed.slice(0, 4).map(function (p) {
          return '' +
            '<div class="product-card">' +
              '<a href="' + p.url + '" class="product-card__media"><img src="' + p.image + '" alt="' + p.title + '" loading="lazy" width="700" height="875"></a>' +
              '<a href="' + p.url + '" class="product-card__info">' +
                '<h3 class="product-card__title">' + p.title + '</h3>' +
                '<div class="product-card__price">' + renderMoney(p.price) + '</div>' +
              '</a>' +
            '</div>';
        }).join('');
        recentSection.hidden = false;
      }

      viewed.unshift(currentProduct);
      viewed = viewed.slice(0, 8);
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(viewed));
    } catch (e) { /* localStorage unavailable (private mode etc.) — fail silently, not a core feature */ }
  }
})();
